import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthService } from 'src/app/auth/auth.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { State } from 'src/app/store/state';
import { IMToolService } from '../services/im-tool.service';
import { MatDialog } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-im-tool',
    templateUrl: './im-tool.component.html',
    styleUrls: ['./im-tool.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class IMToolComponent {
  constructor(
    public imToolService: IMToolService,
    public auth: AuthService,
    public toastService: ToastService,
    public store: Store<State>,
    public dialog: MatDialog,
  ) { }
}
